import { render, staticRenderFns } from "./SupportContentNewDesign.vue?vue&type=template&id=157abc5b&"
import script from "./SupportContentNewDesign.vue?vue&type=script&lang=js&"
export * from "./SupportContentNewDesign.vue?vue&type=script&lang=js&"
import style0 from "./SupportContentNewDesign.vue?vue&type=style&index=0&id=157abc5b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports